import { styled } from "@mui/system";
import Button from "@mui/material/Button";

const CustomButton = styled(Button)(({ theme, color }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: "uppercase",
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: "1px",
  transition: "background-color 0.3s",
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette[color].main,
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: theme.palette[color].dark,
  },
}));

export default CustomButton;
